import { Redo2, RotateCcw, Undo2 } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { useQrContext } from '../state/qr-context';

export function HistoryToolbar() {
  const { actions, canUndo, canRedo } = useQrContext();

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        onClick={actions.undo}
        disabled={!canUndo}
        title="Rückgängig (Strg+Z)"
      >
        <Undo2 aria-hidden="true" />
        Rückgängig
      </Button>

      <Button
        variant="outline"
        size="sm"
        onClick={actions.redo}
        disabled={!canRedo}
        title="Wiederholen (Strg+Umschalt+Z oder Strg+Y)"
      >
        <Redo2 aria-hidden="true" />
        Wiederholen
      </Button>

      <div className="mx-1 h-4 w-px bg-border" aria-hidden="true" />

      <Button
        variant="ghost"
        size="sm"
        onClick={actions.reset}
        title="Alle Einstellungen zurücksetzen"
      >
        <RotateCcw aria-hidden="true" />
        Zurücksetzen
      </Button>
    </div>
  );
}
